import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';

interface DateTextInputProps {
  id?: string;
  value?: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
}

const toDisplay = (val: string | null | undefined): string => {
  if (!val || val.length !== 10) return '';
  const parts = val.split('-');
  if (parts.length !== 3) return '';
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
};

const DateTextInput: React.FC<DateTextInputProps> = ({ id, value, onChange, disabled, readOnly, required }) => {
  const [displayValue, setDisplayValue] = useState(() => toDisplay(value));
  const [error, setError] = useState<string | null>(null);
  const lastExternalValue = useRef(value);

  useEffect(() => {
    if (value !== lastExternalValue.current) {
      lastExternalValue.current = value;
      setDisplayValue(toDisplay(value));
      setError(null);
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    setDisplayValue(raw);

    const match = raw.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
    if (match) {
      const [, dd, mm, yyyy] = match;
      const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
      if (date.getFullYear() === Number(yyyy) && date.getMonth() === Number(mm) - 1 && date.getDate() === Number(dd)) {
        const isoDate = `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
        lastExternalValue.current = isoDate;
        setError(null);
        onChange(isoDate);
      } else {
        setError('Neplatný dátum');
      }
    } else if (raw === '') {
      lastExternalValue.current = '';
      setError(null);
      onChange('');
    } else {
      setError(null);
    }
  };

  return (
    <div>
      <InputText
        id={id}
        value={displayValue}
        onChange={handleChange}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        placeholder="DD.MM.RRRR"
        className={error ? 'p-invalid' : ''}
      />
      {error && <small className="p-error">{error}</small>}
    </div>
  );
};

export default DateTextInput;
